var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIdVerifyDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 134,
    viewBox: "0 0 143 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5852 2.98926L92.2383 20.7377C92.2649 20.7241 92.2914 26.0591 92.3177 26.0451V96.5637C92.3177 97.7586 91.3501 98.7273 90.1566 98.7273H23.1611C21.9676 98.7273 21 97.7586 21 96.5637V5.15283C21 3.95792 21.9676 2.98926 23.1611 2.98926H69.5852Z",
    fill: "#171C60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7168 33.955C35.7168 30.0383 38.8919 26.8633 42.8085 26.8633C46.7251 26.8633 49.9002 30.0383 49.9002 33.955V34.5223H35.7168V33.955Z",
    fill: "#F5F9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.379 21.995C46.379 24.0056 44.7491 25.6355 42.7385 25.6355C40.7279 25.6355 39.098 24.0056 39.098 21.995C39.098 19.9844 40.7279 18.3545 42.7385 18.3545C44.7491 18.3545 46.379 19.9844 46.379 21.995Z",
    fill: "#F5F9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.426 104.832C103.293 100.678 104.973 95.6418 104.973 90.2129C104.973 75.9845 93.4383 64.4502 79.2099 64.4502C64.9816 64.4502 53.4473 75.9845 53.4473 90.2129C53.4473 104.441 64.9816 115.976 79.2099 115.976C84.8671 115.976 90.0984 114.152 94.3482 111.061L114.419 131.433C116.071 133.086 118.75 133.086 120.402 131.433C122.054 129.78 122.054 127.1 120.402 125.448L100.291 105.034C100.336 104.967 100.381 104.899 100.426 104.832Z",
    fill: "#171C60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.21 64.4502C83.9964 64.4503 88.4773 65.7571 92.3174 68.0312V96.5635C92.3174 97.7584 91.3498 98.7275 90.1562 98.7275H54.8896C53.9565 96.062 53.4473 93.197 53.4473 90.2129C53.4474 75.9847 64.9817 64.4502 79.21 64.4502Z",
    fill: "#FFA05C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1738 83.7383C63.8404 83.7384 65.1914 85.0903 65.1914 86.7568C65.1912 88.4232 63.8403 89.7743 62.1738 89.7744H34.0078C32.3414 89.7743 30.9904 88.4233 30.9902 86.7568C30.9902 85.0902 32.3412 83.7384 34.0078 83.7383H62.1738ZM75.251 68.248C76.9174 68.2483 78.2686 69.5991 78.2686 71.2656C78.2685 72.932 76.9174 74.2829 75.251 74.2832H34.0078C32.3413 74.2831 30.9903 72.9322 30.9902 71.2656C30.9902 69.599 32.3412 68.2481 34.0078 68.248H75.251ZM75.251 52.7568C76.9174 52.7571 78.2685 54.1079 78.2686 55.7744C78.2686 57.4409 76.9174 58.7917 75.251 58.792H34.0078C32.3412 58.7919 30.9902 57.441 30.9902 55.7744C30.9903 54.1078 32.3413 52.7569 34.0078 52.7568H75.251Z",
    fill: "#F5F9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1738 83.7383C63.8404 83.7385 65.1914 85.0902 65.1914 86.7568C65.1912 88.4233 63.8403 89.7742 62.1738 89.7744H53.4531C53.4879 87.6929 53.7681 85.6716 54.2686 83.7383H62.1738ZM75.251 68.248C76.9175 68.248 78.2685 69.5991 78.2686 71.2656C78.2686 72.9322 76.9175 74.2832 75.251 74.2832H58.9619C60.8443 71.8938 63.1411 69.8468 65.7432 68.248H75.251Z",
    fill: "#80441A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.5812,
    y: 14.2179,
    width: 22.4571,
    height: 23.639,
    rx: 1.77293,
    stroke: "#F5F9FF",
    strokeWidth: 1.18195
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdVerifyDoc);
export default __webpack_public_path__ + "static/media/icon_id_verify_doc.781c4ac96e2ffa1dd4874e019b2dc1c3.svg";
export { ForwardRef as ReactComponent };